require('../modules/es6.object.to-string');
require('../modules/es6.string.iterator');
require('../modules/web.dom.iterable');
require('../modules/es6.set');
require('../modules/es7.set.to-json');
module.exports = require('../modules/_core').Set;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-helmet/~/core-js/fn/set.js
 ** module id = 838
 ** module chunks = 0
 **/